import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../../context/auth-context'
import './Home.css'
import Footer from '../UIElements/Footer'
import HomeHomeNavigation from './HomeHomeNavigation'
import LoadingSpinner from '../UIElements/LoadingSpinner'
import { NavLink } from 'react-router-dom'
import ErrorModal from '../UIElements/ErrorModal'
import { useForm } from '../../hooks/form-hook'
import { useHttpClient } from '../../hooks/http-hook'
import YouTube from 'react-youtube'
import Carousel from 'react-bootstrap/Carousel'
//
//
//    sponsor images:   D:\PROJECTS\NewKenMemorialPark\FRONTEND\frontend\src\shared\components\images\sponsors
//
//
//  2025:
import FireDept from '../images/sponsors/2025/FireDept.jpg'
import GreenClean from '../images/sponsors/2025/GreenClean.jpg'
import McGuires from '../images/sponsors/2025/McGuires.png'
import RummelFirm from '../images/sponsors/2025/RummelFirm.png'
import WeleskiTransfer from '../images/sponsors/2025/WeleskiTransfer.jpg'
//  2024:
import AlleghenyHealth from '../images/sponsors/AHN.png'
import CareAtHome from '../images/sponsors/CareAtHome.png'
import EagleRiders from '../images/sponsors/EagleRiders.png'
import IceAthletics from '../images/sponsors/IceAthletics.jpg'
import KiskiPrecision from '../images/sponsors/KiskiPrecision.jpg'
import MCMechanical from '../images/sponsors/MCMechanical.png'
import PghIceArena from '../images/sponsors/PIA.jpg'
import RiverForestCC from '../images/sponsors/RiverForestCC.png'
import ShowMe from '../images/sponsors/ShowMe.jpeg'
import mpbhc from '../images/MPBHC.png'

var getYouTubeID = require('get-youtube-id')

const Home = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [formState, inputHandler, setFormData] = useForm()
	const { sendRequest, clearError } = useHttpClient()
	const auth = useContext(AuthContext)
	const [error, setError] = useState()
	const [ids, setIds] = useState([])
	const [videoTitles, setVideoTitles] = useState([])
	const [videoCaptions, setVideoCaptions] = useState([])
	const [loadedVideos, setLoadedVideos] = useState([])
	const [loadedNews, setLoadedNews] = useState([])
	const [loadedCarouselPhotos, setLoadedCarouselPhotos] = useState([])
	const [pic1, setPic1] = useState()
	const [pic2, setPic2] = useState()
	const [pic3, setPic3] = useState()
	//console.log('auth: ' + JSON.stringify(auth))

	//Get all videos designated for the Home Page
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/homePageVideos'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedVideos(responseData.allHomePageVideos)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}

		sendRequest()
	}, [])
	//
	//
	//
	//Get all Carousel photos
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/carouselPhotos'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedCarouselPhotos(responseData.allCarouselPhotos)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	//
	//
	//
	//Get pic 1, 2, and 3
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/getPics123'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				console.log('responseData: ' + JSON.stringify(responseData))

				setPic1(responseData.pic1)
				setPic2(responseData.pic2)
				setPic3(responseData.pic3)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	//pic1 && console.log('pic1: ' + JSON.stringify(pic1))
	//

	let arrayOfTitles, arrayOfIds, arrayOfCaptions
	arrayOfTitles = []
	arrayOfIds = []
	arrayOfCaptions = []
	if (loadedVideos && !isLoading && ids.length === 0) {
		loadedVideos.forEach((video) => {
			arrayOfTitles.push(video.videoTitle)
			arrayOfIds.push(getYouTubeID(video.videoURL))
			arrayOfCaptions.push(video.videoCaption)
		})
	}

	if (arrayOfTitles.length > 0) {
		setVideoTitles(arrayOfTitles)
	}
	if (arrayOfIds.length > 0) {
		setIds(arrayOfIds)
	}
	if (arrayOfCaptions.length > 0) {
		setVideoCaptions(arrayOfCaptions)
	}
	//
	//
	//
	//
	//
	//
	//
	//Get all News
	/* useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/news'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedNews(responseData.allNews)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}

		sendRequest2()
	}, []) */
	//
	//
	//
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && <LoadingSpinner asOverlay />}
				{!isLoading && (
					<div>
						<header className='homeHeader'>
							<HomeHomeNavigation />
							<div className='text-light text-md-right text-center banner headingWriting'></div>
						</header>
						<div className='section pt-5'>
							<div className='row'>
								<div>
									<img src={mpbhc} className='mpbhc' />
								</div>
								<div style={{ marginTop: '1.5rem' }}>
									<h5>Interested in helping? Visit our Amazon Wishlist:</h5>
									<h4 style={{ marginTop: '1.5rem', textAlign: 'center' }}>
										<a
											href='https://www.amazon.com/hz/wishlist/ls/AXP0K69GSHJQ?ref_=wl_share'
											target='_blank'
											style={{ color: '#FF9900' }}
										>
											<i
												className='fa fa-amazon fa-3x mx-3'
												style={{ textShadow: 'black 2px 2px 2px' }}
											></i>
										</a>
									</h4>
								</div>
								<div className='row'>
									<div className='col-lg-3 col-sm-6'></div>
									{!isLoading &&
										loadedNews &&
										loadedNews.map((news, key) => {
											return (
												<div>
													<h1 style={{ color: 'red' }}>{news.newsHeading}</h1>

													<p
														className='caption'
														style={{
															textAlign: 'center',
															color: 'black',
														}}
													>
														{news.newsSubheading}
													</p>
													<p
														className='caption'
														style={{
															textAlign: 'center',
															color: 'black',
														}}
													>
														{news.newsDate}
													</p>
													<p
														className='content'
														style={{
															textAlign: 'center',
															color: 'black',
															marginBottom: '3rem',
															whiteSpace: 'pre-wrap',
														}}
													>
														{news.newsContent}
													</p>
												</div>
											)
										})}
									<div className='col-lg-3 col-sm-6'></div>
								</div>
							</div>
						</div>
						{/* //
							//
							<!-- promotional video -->
					 */}
						<div className='section pt-5'>
							<div className='container-fluid' style={{ height: 'auto' }}>
								<div className='row'>
									{/* Pic One */}
									<div
										className='col-lg-4 siteBox'
										style={{ marginBottom: '1rem' }}
									>
										<img
											src={`${process.env.REACT_APP_AWS_BUCKET}/${pic1}`}
											className='img-thumbnail'
										/>
										{auth.isLoggedIn && (
											<NavLink
												className='changePicButton'
												to={`/admin/pic1Photo`}
												exact
												style={{ textAlign: 'center' }}
											>
												Change Photo
											</NavLink>
										)}
									</div>
									{/* Pic Two */}
									<div
										className='col-lg-4 siteBox'
										style={{ marginBottom: '1rem' }}
									>
										<img
											src={`${process.env.REACT_APP_AWS_BUCKET}/${pic2}`}
											className='img-thumbnail'
										/>
										{auth.isLoggedIn && (
											<NavLink
												className='changePicButton'
												to={`/admin/pic2Photo`}
												exact
												style={{ textAlign: 'center' }}
											>
												Change Photo
											</NavLink>
										)}
									</div>
									{/* Pic Three */}
									<div
										className='col-lg-4 siteBox'
										style={{ marginBottom: '1rem' }}
									>
										<img
											src={`${process.env.REACT_APP_AWS_BUCKET}/${pic3}`}
											className='img-thumbnail'
										/>
										{auth.isLoggedIn && (
											<NavLink
												className='changePicButton'
												to={`/admin/pic3Photo`}
												exact
												style={{ textAlign: 'center' }}
											>
												Change Photo
											</NavLink>
										)}
									</div>
								</div>
							</div>
						</div>
						{/* //
						//
						//
						//     CAROUSEL
						//
						//
						//
						// */}
						<div className='section pt-5'>
							<div className=''>
								<div className='row'>
									<div className='col text-center mb-3'>
										<h1
											className='display-2'
											style={{
												fontWeight: '600',
												color: '#ee2e30',
												textShadow: '2px 2px 2px #1e154d',
											}}
										>
											Check it out!
										</h1>
									</div>
								</div>
								{/* //
								//
								// */}
								<div className='section'>
									<div className='row'>
										<div className='col-lg-3 col-sm-6'></div>
										{!isLoading && loadedCarouselPhotos && (
											<Carousel fade>
												{loadedCarouselPhotos.map((photo, key) => (
													<Carousel.Item interval={7000}>
														<img
															className='d-block carouselPhoto'
															src={`${process.env.REACT_APP_AWS_BUCKET}/${photo.photo}`}
															alt='Image One'
														/>
													</Carousel.Item>
												))}
											</Carousel>
										)}
										<div className='col-lg-3 col-sm-6'></div>
									</div>
								</div>
							</div>
						</div>
						{/* //
						//
						//
						//    END OF CAROUSEL
						//
						//
						//
						// */}
						{/* //
						//
						//
						//    VIDEOS:
						//
						//
						//
						// */}
						{loadedVideos.length > 0 && (
							<div
								className='section pt-5'
								style={{ backgroundColor: '#e0e0e0' }}
							>
								<div className=''>
									<div className='row'></div>

									<div className='row'>
										<div className='col-lg-3 col-sm-3'></div>
										<div className='col-lg-6 col-sm-6'>
											{!isLoading &&
												loadedVideos &&
												loadedVideos.map((video, key) => {
													return (
														<div>
															<div className='col text-center mb-0'>
																<h1 className='text-sh-dark display-2'>
																	Watch!
																</h1>
															</div>
															<h1 style={{ color: 'red' }}>
																{video.videoTitle}
															</h1>

															<p
																className='caption'
																style={{
																	textAlign: 'center',
																	color: 'black',
																}}
															>
																{video.videoCaption}
															</p>
															{
																<YouTube
																	style={{ paddingBottom: '3rem' }}
																	videoId={ids[key]}
																/>
															}
														</div>
													)
												})}
										</div>
										<div className='col-lg-3 col-sm-3'></div>
									</div>
								</div>
							</div>
						)}
						{/* //
							//
							//
							//   SPONSORS:
							//
							// */}
						<div
							className='section pt-5'
							style={{ paddingBottom: '4rem', background: 'white' }}
						>
							<div className='row'>
								<div className='col text-center mb-0'>
									<h1
										className='watch'
										style={{ marginBottom: '2.5rem', fontSize: '3rem' }}
									>
										Thank you to our 2025 sponsors:
									</h1>
								</div>
							</div>
							<div className='row paddingRow'>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={McGuires} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={GreenClean} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={FireDept} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={RummelFirm} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={WeleskiTransfer} className='img-thumbnail' />
								</div>
							</div>
							{/* //
							//
							// */}
							<div className='row' style={{ marginTop: '2rem' }}>
								<div className='col text-center mb-0'>
									<h1
										className='watch'
										style={{ marginBottom: '2.5rem', fontSize: '3rem' }}
									>
										...and to our sponsors from 2024:
									</h1>
								</div>
							</div>
							<div className='row'>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={AlleghenyHealth} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={CareAtHome} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={EagleRiders} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={IceAthletics} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={ShowMe} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={KiskiPrecision} className='img-thumbnail' />
								</div>
							</div>
							<div className='row'>
								<div className='col-lg-2 col-sm-2 siteBox'></div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={MCMechanical} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={PghIceArena} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'>
									<img src={RiverForestCC} className='img-thumbnail' />
								</div>
								<div className='col-lg-2 col-sm-2 siteBox'></div>
							</div>
							<div className='row'>
								<h5 className='padding'>
									Interested in becoming a sponsor for the 2025 season?
								</h5>
								<h5 className='padding'>
									Email us at{' '}
									<a href='mailto:memorialparkdek@gmail.com'>
										memorialparkdek@gmail.com
									</a>
								</h5>
							</div>
						</div>
						{/* //
							//
							//
							//
							// */}
						<div
							className='section pt-5 videos'
							style={{ paddingBottom: '4rem' }}
						>
							<div className=''>
								<div className='row'>
									<div className='col text-center mb-3'>
										<h1
											className='display-2'
											style={{
												fontWeight: '600',
												color: '#ee2e30',
												textShadow: '2px 2px 2px #1e154d',
											}}
										>
											Come Join Us!
										</h1>
									</div>
								</div>
								<div className='row'>
									<div className='col'>
										<h4
											className='newsAndUpdates'
											style={{
												textAlign: 'center',
												color: 'black',
												marginLeft: '15%',
												marginRight: '15%',
											}}
										>
											1500 Stevenson Blvd
											<br></br>
											New Kensington, PA 15068
											<br></br>
											{/* <a
											className='phoneNumber'
											href={'tel:4127939800'}
											style={{ textAlign: 'center', fontSize: 'medium' }}
										>
											412-793-9800
										</a> */}
											<div style={{ textAlign: 'center', fontSize: 'medium' }}>
												memorialparkdek@gmail.com
											</div>
										</h4>
									</div>
								</div>
							</div>
						</div>
						{/* //
				//
				//
				// */}
						{/* <div className='section p-5 container-gray'></div> */}
					</div>
				)}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default Home
